import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Determinar URL y versión basada en el entorno
const getI18nConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    return {
      baseUrl: './locales',
      version: ''
    };
  }

  if (process.env.REACT_APP_ENVIRONMENT === 'qa') {
    return {
      baseUrl: process.env.REACT_APP_I18N_QA_URL,
      version: process.env.REACT_APP_I18N_QA_VERSION
    };
  }

  return {
    baseUrl: process.env.REACT_APP_I18N_BASE_URL,
    version: process.env.REACT_APP_API_VERSION
  };
};

const { baseUrl, version } = getI18nConfig();
const fullUrl = version ? `${baseUrl}/${version}` : baseUrl;

const backendOptions = {
  loadPath: `${fullUrl}/locales/{{lng}}/{{ns}}.json`,
  requestOptions: {
    cache: 'default'
  }
};

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'es',
    lng: 'es',
    backend: backendOptions,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    preload: ['es', 'en'],
    react: {
      useSuspense: true
    },
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
